import * as THREE from 'three';
import { gsap } from "gsap";

export default class ParticleSystem{

  constructor(scene,texture){
    this.scene = scene;
    this.material = new THREE.SpriteMaterial( {
      map: texture,
      opacity:.5,
      transparent:true,
      color: new THREE.Color( 0xffffff),
      blending: THREE.AdditiveBlending
     });
    this.time = 0;
    this.mode = "paused";
    this.speed = 1.5;

  }

  init(max,pos){

    this.particles = [];


    this.group = new THREE.Group();
    this.group.position.copy(pos);
    this.scene.add(this.group);

    // create particles
    for(let i = 0; i < 300; i++){
        const sprite = new THREE.Sprite( this.material );
        sprite.scale.set(0,0,0);
        sprite.alive = false;
        sprite.velocity = new THREE.Vector3();
        sprite.visible = false;
        this.particles.push(sprite);
        this.group.add(sprite);
    }

    this.target = new THREE.Vector3();
  }

  updateAsSparkles(dt,fpos){

    if(this.mode == "paused")
      return;

    this.time += dt;
    let targetRadius = .25;

    this.group.position.x = .8*this.group.position.x + .2*fpos.x;
    this.group.position.y = .8*this.group.position.y + .2*fpos.y;
    this.group.position.z = .8*this.group.position.z + .2*fpos.z;

    this.target.x = targetRadius * Math.sin(this.time*this.speed);
    this.target.y = .2;// + .01 * Math.sin(this.time*.1);
    this.target.z = targetRadius * Math.cos(this.time*this.speed);

    let totalMade = 0;
    let totalAlive = 0;

    if(this.mode == "sparkle"){
      this.particles.forEach((item, i) => {
        if(totalMade < 2 && !item.alive){
          this.startParticle(item);
          totalMade++;
        }else if(item.alive){
          item.position.add(item.velocity);
          item.velocity.multiplyScalar(.9);
          totalAlive++;
        }
      });
    }else if(this.mode == "fade"){
      this.particles.forEach((item, i) => {
        if(item.alive){
          item.position.add(item.velocity);
          item.velocity.multiplyScalar(.9);
          totalAlive++;
        }
      });

      if(totalAlive == 0){
        this.mode = "paused";
      }
    }

    //console.log("totalAlive",totalAlive);
  }

  startParticle(particle){
    particle.alive = true;
    particle.position.copy(this.target);
    let velFactor = .005;
    particle.velocity.set( (Math.random()-.5) * velFactor, (Math.random()-.5) * velFactor, (Math.random()-.5) * velFactor);

    let scale = .025 + Math.random()*.025;
    particle.scale.set(0,0,0);
    particle.visible = true;
    //particle.material.opacity = 0;
    gsap.to(particle.scale,{x:scale,y:scale,z:scale,duration:0});
    gsap.to(particle.scale,{x:0,y:0,z:0,duration:1,ease:"sine.inOut",onComplete:function(){
      particle.alive = false;
      particle.visible = false;
      particle.velocity.set(0,0,0);
    }.bind(this)})
  }

  setToSparkle(duration,fpos){

    if(this.sparkleTM)
      clearTimeout(this.sparkleTM);

    this.group.position.copy(fpos);

    this.particles.forEach((item, i) => {
      item.alive = false;
      item.visible = false;
      item.velocity.set(0,0,0);
    });

    this.speed = 2;

    let speed = {val:3};
    this.material.opacity = .5;
    gsap.to(this.material,{opacity:0,duration:duration*.75,overwrite:true,onUpdate:function(){
      //this.speed = speed.val;
    }.bind(this)});


    this.mode = "sparkle";
    this.sparkleTM = setTimeout(function(){
      this.mode = "fade";
    }.bind(this),duration*1000);
  }

  doBubbles(){
    this.material.alphaTest = .3;
    this.material.opacity = 1;
    this.material.transparent = false;


    //console.log("do bubbles");
    this.particles.forEach((item, i) => {
      item.alive = true;
      item.visible = true;
      item.velocity.set(0,0,0);
      item.scale.set(0,0,0);
      let scale = .025 + Math.random()*.025;
      let speed = 100 + Math.random()*50;

      item.position.set(Math.random()*6-3,0.025,Math.random()*6-3);
      let x = item.position.x + ( Math.random()*2 - 1);
      let y = 5 + Math.random()*2;
      let z = item.position.z + ( Math.random()*2 - 1);
      let delay = Math.random();

      gsap.to(item.position,{x:x,y:y,z:z,duration:speed,delay:delay,overwrite:true,onComplete:function(){
        item.visible = false;
      }.bind(this)});
      gsap.to(item.scale,{x:scale,y:scale,z:scale,delay:delay,duration:.5,overwrite:true});
    });
  }

  clearBubbles(){
    this.particles.forEach((item, i) => {
      item.visible = false;
    });
  }
};
